import { Checkbox, Snackbar } from "@mui/material";
import MuiAlert, { AlertColor } from "@mui/material/Alert";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { CancelIcon } from "../../../assets/icons/icons.tsx/CancelIcon";
import { ConfirmIcon } from "../../../assets/icons/icons.tsx/ConfirmIcon";
import moveItem from "../../../assets/icons/moveItem.svg";
import CustomDropdown from '../../../components/Dropdown/DropdownComp';
import LoaderComp from "../../../components/Loader/LoaderComp";
import { CustomModal } from "../../../components/Modal/CustomModal";
import { Move, MoveList } from "../../../services/Item/ItemServicesCRUD";
import { GetOrgWorkSpaceAdmTrim } from "../../../services/WorkSpaceServices";
import { filesSelected } from "../WorkSpaceItemListFile";
import { CustomButton } from "./components/CustomButton";
import { FolderPath } from "./components/FolderPath";
import SelectedList from "./components/SelectedList";
import MovedSuccess from "./MovedSuccess";


export interface FatherfolderProps {
  id?: string,
  name?: string,
}

export interface WorkspaceProps {
  workspaceId: string;
  workspaceName: string;
}

interface MoveInBatchProps {
  listItem: filesSelected[];
  isModalOpen: boolean;
  hideModal: () => void;
  batchRefresh: () => void;
  idWorkspace: string;
  isMovingOneItem: boolean;
}

const MoveInBatch: React.FC<MoveInBatchProps> = ({ isModalOpen, hideModal, listItem, batchRefresh, idWorkspace, isMovingOneItem }) => {
  const { t, i18n } = useTranslation();
  const [isHoveredButtonCancel, setIsHoveredButtonCancel] = useState(false);

  const [fatherfolder, setFatherFolder] = useState<FatherfolderProps | undefined>();
  const [workspaceIdSelected, setWorkspaceIdSelected] = useState<WorkspaceProps>({ workspaceId: "", workspaceName: "" })
  const [load, setLoad] = useState<boolean>(false)
  const [workspaceOptions, setWorkspaceOptions] = useState<{ key: string | number; text: string }[]>([]);
  const [limit, setLimit] = useState<number>(50);
  let [skip, setSkip] = useState<number>(0);
  const [isMovedSuccess, setIsMovedSuccess] = useState<boolean>(false)
  const [isJustWorkspace, setIsJustWorkspace] = useState<boolean>(false)
  const [showSnackBar, setShowSnackBar] = useState<boolean>(false);
  const [messageSnack, setMessageSnack] = useState<string>("");
  const [alertColor, setAlertColor] = useState<AlertColor>("success");
  const { nameOrg } = useParams();

  const handleCloseSnackBar = (event: any, reason: any) => {
    setShowSnackBar(false);
  };
  
  const handleCloseSnackBarPO = (event: any) => {
    setShowSnackBar(false);
  };

  useEffect(() => () => setShowSnackBar(false), [])

  function move() {
      setLoad(true);console.log("MOVE")
      Move({
          idMongo: listItem[0]?.id,
          idMongoNewFolder: fatherfolder?.id!,
          idNewWorkspace: workspaceIdSelected.workspaceId 
      })
      .then(() =>{
        setShowSnackBar(true);
        setMessageSnack("Item movido com sucesso");
        setAlertColor("success");

        hideModal();
        setIsMovedSuccess(true);
        batchRefresh();
      })
      .catch((error) =>{
        setShowSnackBar(true);
        setMessageSnack(error.response.data);
        setAlertColor("error");
        console.log(error.response.data)
      })
      .finally(() => {
        setLoad(false);
      })
  }
  

  function moveItemsList() {
    setLoad(true)
    const idItens = listItem.map(item => item.id)
console.log("MOVELIST")
    MoveList({ idMongoNewFolder: isJustWorkspace ? undefined : fatherfolder?.id, idItens: idItens, idNewWorkspace: workspaceIdSelected.workspaceId }).then(() => {
      setShowSnackBar(true);
      setMessageSnack("Item movido com sucesso");
      setAlertColor("success");

      batchRefresh()
      setIsMovedSuccess(true)
      hideModal();
    })
    .catch(error => {
      setShowSnackBar(true);
      setMessageSnack(error.response.data);
      setAlertColor("error");   
    })
    .finally(() => {
      setLoad(false)
    })
  }

  useEffect(() => {
    if (nameOrg) {
      GetOrgWorkSpaceAdmTrim(nameOrg, skip, limit, false).then((newWork) => {
        setSkip(newWork.length);

        const newOptions = newWork.map(workspace => ({ key: workspace.id as string, text: workspace.name as string }));

        setWorkspaceOptions(newOptions);
      });
    }
  }, [])

  const handleWorkspace = (event: any): void => {
    const selectedKey = event.target.value as string;
    const selectedOption = workspaceOptions?.find(option => option.key === selectedKey);
    const selectedText = selectedOption ? selectedOption.text : '';

    setWorkspaceIdSelected({ workspaceId: selectedKey, workspaceName: selectedText });
  };

  function handleCheckBoxJustWorkspace(event: React.ChangeEvent<HTMLInputElement>) {
    setIsJustWorkspace(event.target.checked)

    const selectedOption = workspaceOptions?.find(option => option.key === idWorkspace);
    const selectedText = selectedOption ? selectedOption.text : '';
    setWorkspaceIdSelected({ workspaceId: idWorkspace, workspaceName: selectedText })
  }

  const closeModal = () => {
    setIsMovedSuccess(false)
  };

  const closeCustomModal = () => {
    setFatherFolder(undefined)
    setWorkspaceIdSelected({ workspaceId: "", workspaceName: "" })
    setIsJustWorkspace(false)
    hideModal()
  };

  return (
    <>
      <CustomModal
        isModalOpen={isModalOpen}
        hideModal={closeCustomModal}
      >
        <div style={{ width: "600px" }}>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <img src={moveItem} alt='moveItemIcon' />
          </div>

          <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
            <div style={{ marginTop: "16px", font: "normal normal 600 20px/39px Segoe UI", color: "#2D2D2D" }}>
              {t("MoveInBatch.title")}
            </div>
          </div>
          <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
            <div style={{ width: "540px", textAlign: "center", font: "normal normal normal 16px/24px Segoe UI", color: "#575757" }}>
              {t("MoveInBatch.header")}
            </div>
          </div>

          <div style={{ borderTop: "1px solid rgb(34, 99, 141, 0.1)", marginTop: "20px", marginBottom: "20px" }}></div>

          <div style={{ font: "normal normal 600 14px/21px Segoe UI", color: "#2D2D2D" }}>{t("MoveInBatch.titleListItens")}</div>

          <SelectedList listItem={listItem} />

          <div style={{ borderTop: "1px solid rgb(34, 99, 141, 0.1)", marginTop: "20px", marginBottom: "20px" }}></div>

          <div style={{ font: "normal normal 600 14px/21px Segoe UI", color: "#2D2D2D" }}>{t("MoveInBatch.titleMoveFor")}</div>

          <div style={{ paddingTop: "12px" }}>
            {workspaceOptions &&
              <CustomDropdown
                label={"Workspace"}
                placeholder={t("RecicleBin.select")}
                options={workspaceOptions}
                onChange={handleWorkspace}
                selectedKey={workspaceIdSelected.workspaceId}
                suffix={t("RecicleBin.defalt")}
                isDisabled={isJustWorkspace}
                styleLabel={{transform: "none", WebkitTransform: "none"}}
              />
            }

            <FolderPath
              idWorkspace={workspaceIdSelected.workspaceId != "" ? workspaceIdSelected.workspaceId : ""}
              newFatherFolder={setFatherFolder}
              isDisabled={isJustWorkspace}
              listItensTypeFolder={listItem.filter(item => item?.isFolder).map(item => item.id)}
            />
          </div>

          <div style={{ display: "flex", alignItems: "center" }}>
            <Checkbox sx={{
              padding: "13px 5px",
              '& .MuiSvgIcon-root': { fontSize: 21.4 },
              color: "#22638D",
              '&.Mui-checked': {
                color: "#22638D",
              },
            }} onChange={handleCheckBoxJustWorkspace} />
            <div style={{ font: "normal normal normal 14px/21px Segoe UI", color: "#2D2D2D" }}>{t("MoveInBatch.checkbox")}</div>
          </div>

          <div style={{ width: '100%', display: 'flex', gap: "20px", alignItems: "end" }}>
            <CustomButton
              icon={<CancelIcon color={isHoveredButtonCancel ? "#FFFFFF" : "#22638D"} />}
              onclick={closeCustomModal}
              setIsHovered={setIsHoveredButtonCancel}
              text={t("RecicleBin.cancel")}
              backgrondColor='#FCFCFC'
              color='#22638D'
              hoveredBackgrondColor='#0d476d'
              hoveredColor='#FFFFFF'
            />
            {load ? (
              <div style={{ width: "100%", height: "36px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <LoaderComp />
              </div>
            ) : (
              <CustomButton
                icon={<ConfirmIcon />}
                onclick={isMovingOneItem ? move : moveItemsList}
                text={t("RecicleBin.confirm")}
                backgrondColor='#22638D'
                color='#FFFFFF !important'
                hoveredBackgrondColor='#0d476d'
                isDisabled={workspaceIdSelected.workspaceId == ""}
              />
            )
            }
          </div>
        </div>
        <Snackbar
          open={showSnackBar}
          autoHideDuration={6000}
          message="Archived"
          onClose={handleCloseSnackBar}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          sx={{ bottom: { xs: 50, sm: 20 } }}
        >
          <MuiAlert
            elevation={6}
            variant="filled"
            sx={{ width: "100%" }}
            severity={alertColor}
            onClose={handleCloseSnackBarPO}
          >
            {messageSnack}
          </MuiAlert>
        </Snackbar>
      </CustomModal>
      <MovedSuccess
        hideModal={closeModal}
        isConfirmed={isMovedSuccess}
        item={listItem}
        newFatherFolder={fatherfolder}
        newWorkspace={workspaceIdSelected}
        nameOrg={nameOrg!}
      />
    </>
  );
};

export default MoveInBatch;